import _ from 'lodash';
// 这里分成模块方便后续扩展和独立管理
export const customerFormConfig = {
    name: 'customerForm',
    formData: {},
    searchFields: [
        {
            name: '请输入',
            value: 'customerSearchCondition',
            type: 'input',
            isFixed: true,
            span: 24
        }
    ]
};

export const opportunityFormConfig = {
    name: 'opportunityForm',
    formData: {},
    searchFields: [
        {
            name: '请输入',
            value: 'opportunitySearchCondition',
            type: 'input',
            isFixed: true,
            span: 24
        }
    ]
};

export const contractFormConfig = {
    name: 'contractForm',
    formData: {},
    searchFields: [
        {
            name: '请输入',
            value: 'contractSearchCondition',
            type: 'input',
            isFixed: true,
            span: 24
        }
    ]
};

export const registrationFormConfig = {
    name: 'registrationForm',
    formData: {},
    searchFields: [
        {
            name: '请输入',
            value: 'customerSearchCondition',
            type: 'input',
            isFixed: true,
            span: 24
        }
    ]
};
